import Repository from './repository';

const resource = '/webhooks';
export default {
	find() {
		return Repository.getWithAuth(`${resource}/find`);
	},
	getDetailsById(id) {
		return Repository.getWithAuth(`${resource}/${id}`);
	},
	create(payload) {
		return Repository.postWithAuth(
			`${resource}/create`,
			payload,
			{},
			{ noCache: true }
		);
	},
	delete(id) {
		return Repository.deleteWithAuth(`${resource}/delete/${id}`);
	},
	update(payload, id) {
		return Repository.postWithAuth(
			`${resource}/update/${id}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	findModules() {
		return Repository.getWithAuth(`${resource}/modules`);
	},
	findByEventType(payload) {
		return Repository.postWithAuth(`${resource}/logs/eventType`, payload);
	},
	findEventLogs(payload) {
		return Repository.postWithAuth(`${resource}/logs/find`, payload);
	},
	getEventLogsById(id) {
		return Repository.getWithAuth(`${resource}/logs/${id}`);
	},
};
